module.exports = __webpack_public_path__ + "img/schedule-logo.4c607fb9.svg";